export default __webpack_public_path__ + "static/media/operation.b58040ad.svg";